import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('SubHeader', null, { withChildren: true });
